var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoodcutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lorc-wood-axe-gradient-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.344 22.813L205.03 37.906L276.812 84.281L285.75 71.471C270.13 47.838 241.597 30.501 215.344 22.814Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.874 41.656C148.554 76.996 97.714 146.816 71.156 186.969C133.116 213.333 184.169 256.531 204.376 306.562C209.44 319.102 212.501 332.128 213.156 345.312C250.029 335.562 293.496 308.382 330.406 274.812C360.511 247.432 386.318 215.697 401.812 187.062L176.875 41.655Z",
    className: "selected",
    fill: "#9b9b9b",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.531 197.186C400.695 228.224 373.818 260.27 342.814 288.469C302.604 325.039 255.576 354.943 212.344 364.499C211.235 372.965 209.105 381.265 206.001 389.219C197.091 412.051 179.771 433.852 153.345 453.811C218.023 464.766 288.48 440.706 349.189 400.124C413.399 357.201 466.029 296.012 488.469 243.061L417.532 197.186Z",
    className: "",
    fill: "#9b9b9b",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.814 213.782L16.5 313.72L16.5 457.437L152.375 262.625C134.145 244.112 110.963 227.33 84.812 213.781Z",
    className: "",
    fill: "#8b572a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodcutter);
export default __webpack_public_path__ + "static/media/Woodcutter.570600c44f909951aa489c6e510f40b1.svg";
export { ForwardRef as ReactComponent };